import React from 'react';
import { redirectToHome } from '../../utils';
import { trans } from '../../localization/language';

export default class UnlockDone extends React.Component {
	componentDidMount() {
		redirectToHome({url: '/'});
	}

	render() {
		return (
			<div className="main">
				<div className="content">
					<div className="content-item content-item--ipage content-item--single">
						<div className="content-item__title">
							{trans('unlock_title')}
						</div>
						<div className="content-item__main">
							<div className="content-item--ipage__main">
								<div className="content__result content__result--successful">
									<div className="content__result-icon content__result-icon--successful"></div>
									<div className="content__result-txt">
										{trans('unlock_success')}
									</div>
								</div>
								<div className="content__sendinfo">
									{trans('redirect_home_msg')} <span id="J-success-cdele"></span>s
								</div>
								<div className="content__submit-wrap">
									<a href="/" className="content__submit">{trans('back_home')}</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./app/components/unlock/UnlockDone.js